import React from 'react';
import { motion } from 'framer-motion';
export function JoinUs() {
  const opportunities = [{
    title: 'Ph.D. Positions',
    description: 'Fully funded positions for candidates with strong backgrounds in thermal sciences, fluid mechanics, or related fields.'
  }, {
    title: 'M.Tech/M.S. Projects',
    description: 'Thesis projects available in spray cooling, heat pipes, battery thermal management, and computational methods.'
  }, {
    title: 'Research Internships',
    description: 'Summer and semester-long internship opportunities for undergraduate students.'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-180">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#800000] via-[#6B0F1A] to-[#3A0000] z-0" data-id="element-181"></div>

      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-10 z-0" style={{
      backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)',
      backgroundSize: '40px 40px'
    }} data-id="element-182"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-183">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-184">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-bold text-white font-serif mb-4" data-id="element-185">
            Join Our Research Group
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg text-white/80" data-id="element-186">
            We are always looking for motivated students and researchers to join
            MT²RL
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-187">
          {opportunities.map((opp, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-8 hover:bg-white/15 transition-colors" data-id="element-188">
              <h3 className="text-xl font-bold text-white mb-3 font-serif" data-id="element-189">
                {opp.title}
              </h3>
              <p className="text-white/80 text-sm leading-relaxed" data-id="element-190">
                {opp.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-191">
          <a href="#contact" className="inline-block px-8 py-4 bg-white text-[#800000] rounded-md font-bold text-lg hover:bg-gray-100 transition-colors shadow-lg" data-id="element-192">
            Contact Us
          </a>
        </motion.div>
      </div>
    </section>;
}